import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { Observable, catchError, switchMap, throwError } from 'rxjs';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const authInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);
    let newReq = req.clone();

    if (
        authService.accessToken &&
        !AuthUtils.isTokenExpired(authService.accessToken)
    ) {
        newReq = req.clone({
            headers: req.headers.set(
                'Authorization',
                'Bearer ' + authService.accessToken
            ),
        });
    }

    return next(newReq);
};

export const unauthErrorInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error instanceof HttpErrorResponse && error.status === 401 && !(req.url.includes('auth/login') || req.url.includes('auth/refresh-tokens'))) {
                const refreshToken = authService.refreshToken;
                if (refreshToken) {
                    return authService.refreshAllTokens().pipe(
                        switchMap(() => {
                            let newReq = req.clone();

                            newReq = req.clone({
                                headers: req.headers.set(
                                    'Authorization',
                                    'Bearer ' + authService.accessToken
                                ),
                            });
                            return next(newReq);
                        }),
                        catchError((error) => {
                            if (error.status == '403' || error.status === '401') {
                                authService.signOut();
                                location.reload();
                            }
                            return throwError(() => error);
                        })
                    );
                }
            }

            return throwError(() => error);
        })
    );
};
